export enum EnumPqrsdConditions {
  CITIZEN_EXTENSION = 'SPC',
  ASK_FOR_INFORMATION = 'SIN',
  ADD_CITIZEN_EXTENSION_DAYS = 'SP',
  COMPLETE_INFORMATION = 'CIN',
  VOLUNTARY_RETIREMENT = 'DV',
  PENDING_INFORMATION_DATE = 'FPI',
}
